import { render, staticRenderFns } from "./schedule-widgets.vue?vue&type=template&id=5d7dc10b"
import script from "./schedule-widgets.vue?vue&type=script&lang=js"
export * from "./schedule-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports